module.exports = __webpack_public_path__ + "static/media/pencil_woman_hat.9c7ccc53.jpg";